export default __webpack_public_path__ + "1.17.19/static/media/libreView-small.22d31a32.svg";